import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// redux
import { connect } from 'react-redux';

import { Typography } from '@comparethemarketau/manor-typography';

import { Separator } from './separator';
import { toFixedNumber } from './number_formatter';
import { paymentFrequencyStateMapping, frequencyFilterTypes } from '../../filters/common/filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    productPriceMonthlyNoticeContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        marginTop: theme.spacing[4],
        marginBottom: theme.spacing[8]
    },
    notice: {
        fontSize: theme.fontSize.xs,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey800,
        lineHeight: theme.lineHeight.relaxed
    },
    seprator: {
        margin: {
            left: '1rem',
            right: '1rem'
        }
    }
}));

const _ProductPriceMonthlyNotice = ({ frequencyFilter, productMonthlyFirstMonth, productAnnualisedMonthlyPremium }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const productMonthlyFirstMonthFixed = toFixedNumber(productMonthlyFirstMonth);
    const productAnnualisedMonthlyPremiumFixed = toFixedNumber(productAnnualisedMonthlyPremium);

    return (
        (frequencyFilter === 'monthly' && productMonthlyFirstMonthFixed && productAnnualisedMonthlyPremiumFixed)
        && (
            <div className={classes.productPriceMonthlyNoticeContainer}>
                <Typography className={classes.notice}>{`1st month: $${productMonthlyFirstMonthFixed}`}</Typography>
                <Separator className={classes.seprator} type="vertical" insideFlexbox />
                <Typography className={classes.notice}>{`Total: $${productAnnualisedMonthlyPremiumFixed}`}</Typography>
            </div>
        )
    );
};

_ProductPriceMonthlyNotice.propTypes = {
    productMonthlyFirstMonth: PropTypes.number,
    productAnnualisedMonthlyPremium: PropTypes.number,
    /**
     * monthly or annual from redux
     */
    frequencyFilter: PropTypes.oneOf(frequencyFilterTypes)
};

const ProductPriceMonthlyNotice = connect(paymentFrequencyStateMapping)(_ProductPriceMonthlyNotice);

export { ProductPriceMonthlyNotice };
